import http from "../../../api/apiClient";

export type HealthContacts = {
  doctorName?: string | null;
  doctorPhone?: string | null;
  emergencyContact?: string | null;
  emergencyPhone?: string | null;
};

/** Health profile of a child as returned by the backend (parent portal only). */
export type ChildHealthProfile = {
  childId: string;
  familyId?: string | null;
  exists: boolean;
  reviewedAt?: string | null;
  reviewNeeded: boolean;
  family: HealthContacts;
  ownDoctor: boolean;
  ownEmergencyContact: boolean;
  own: HealthContacts;
  allergies?: string | null;
  medicalNotes?: string | null;
  swimmingDiploma?: boolean | null;
  /** What applies to the child: its own doctor/emergency contact where set, otherwise the family's. */
  effective: HealthContacts;
};

export type ChildHealthProfileUpdate = {
  family: HealthContacts | null;
  ownDoctor: boolean;
  ownEmergencyContact: boolean;
  own: HealthContacts | null;
  allergies?: string | null;
  medicalNotes?: string | null;
  swimmingDiploma?: boolean | null;
};

const path = (childId: string | number) =>
  `/parent-portal/children/${encodeURIComponent(String(childId))}/health-profile`;

export const fetchChildHealthProfile = async (childId: string | number): Promise<ChildHealthProfile> => {
  const { data } = await http.get<ChildHealthProfile>(path(childId));
  return data;
};

export const saveChildHealthProfile = async (
  childId: string | number,
  update: ChildHealthProfileUpdate,
): Promise<ChildHealthProfile> => {
  const { data } = await http.put<ChildHealthProfile>(path(childId), update);
  return data;
};

export const deleteChildHealthProfile = async (childId: string | number, includeFamily: boolean): Promise<void> => {
  await http.delete(path(childId), { params: { includeFamily } });
};

/** Payload that confirms the profile as it is (yearly check). */
export const toUpdate = (profile: ChildHealthProfile): ChildHealthProfileUpdate => ({
  family: profile.family || null,
  ownDoctor: !!profile.ownDoctor,
  ownEmergencyContact: !!profile.ownEmergencyContact,
  own: profile.own || null,
  allergies: profile.allergies ?? null,
  medicalNotes: profile.medicalNotes ?? null,
  swimmingDiploma: profile.swimmingDiploma ?? null,
});
